<script setup lang="ts">
import { computed } from "vue";

import { useAnalyticsEventTiModel } from "@/hooks/useAnalytics/useAnalytics";
import useStoreResetter from "@/hooks/useStoreResetter/useStoreResetter";
import useTranslate from "@/hooks/useTranslate/useTranslate";
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useEvaluationResultStore } from "@/stores/evaluationResult/evaluationResult";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { useTIWStore } from "@/stores/tiw/tiw";

import HandedDevice from "../../handedDevice/handedDevice.vue";
import Modal from "../../modal/modal.vue";

const TIWStore = useTIWStore();
const ChooseDeviceStore = useChooseDeviceStore();
const EvaluationResultStore = useEvaluationResultStore();
const HowYouRateDeviceStore = useHowYouRateDeviceStore();

function onEditHandler() {
    useStoreResetter();
    TIWStore.switchStep("chooseDevice");
    useAnalyticsEventTiModel();
}

// function chooseDelivery(method: I_Choose_Delivery) {
//   ChooseDelivery.chosenDelivery = method
//   TIWStore.switchStep('successfulEvaluation')
// }

const handedDevicePrice = computed(() => {
    if (typeof HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale === "object") {
        return HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale?.tradeInSale;
    }

    return HowYouRateDeviceStore?.calculatedDeviceData?.panelTradeInSale;
});
</script>

<template>
    <Modal class="tiw__step__chooseDelivery">
        <template #header>
            <p class="tiw__h2">
                {{ useTranslate("tiw__chooseDelivery__title") }}
            </p>
        </template>
        <div class="tiw__step__chooseDelivery__getDiscount">
            <HandedDevice
                :device-price="handedDevicePrice"
                :device-chain="ChooseDeviceStore.deviceChain"
                :device-state="HowYouRateDeviceStore.rate"
                :device-preview="ChooseDeviceStore.deviceImagePreview"
                :device-grade="HowYouRateDeviceStore.deviceGrade"
                :device-no-grade="EvaluationResultStore.stateOfEvaluation === 'UNKNOWN'"
                :device-terminated="EvaluationResultStore.stateOfEvaluation === 'TERMINATED'"
                :on-edit="onEditHandler"
            />
            <button class="tiw__step__chooseDelivery__getDiscount__item">
                <img src="\img\courier_delivery.svg" alt="courier delivery" />
                <div>
                    <p class="tiw__step__chooseDelivery__getDiscount__item__title">
                        {{ useTranslate("tiw__chooseDelivery__courierDelivery__title") }}
                    </p>
                    <p class="tiw__step__chooseDelivery__getDiscount__item__text">
                        {{ useTranslate("tiw__chooseDelivery__courierDelivery__text") }}
                    </p>
                </div>
            </button>
            <button class="tiw__step__chooseDelivery__getDiscount__item">
                <img src="\img\pick_up_store.svg" alt="pick up in store" />
                <div>
                    <p class="tiw__step__chooseDelivery__getDiscount__item__title">
                        {{ useTranslate("tiw__chooseDelivery__pickUp__title") }}
                    </p>
                    <p class="tiw__step__chooseDelivery__getDiscount__item__text">
                        {{ useTranslate("tiw__chooseDelivery__pickUp__text") }}
                    </p>
                </div>
            </button>
        </div>
    </Modal>
</template>

<style lang="scss" src="./chooseDelivery.scss"></style>
